export default "__VITE_ASSET__87e754f0__"